<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    title="详情"
    width="600px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="close"
    :visible.sync="dialogVisible"
  >
    <div>
      <el-form ref="form" :model="form" label-width="120px" size="small">
        <el-form-item label="账号:" prop="username">
          <FormatSpan>{{ form.username }}</FormatSpan>
        </el-form-item>
        <el-form-item label="真实姓名:" prop="realName">
          <FormatSpan>{{ form.realName }}</FormatSpan>
        </el-form-item>
        <el-form-item label="手机号:" prop="phone">
          <FormatSpan>{{ form.phone }}</FormatSpan>
        </el-form-item>
        <el-form-item label="邮箱:" prop="email">
          <FormatSpan>{{ form.email }}</FormatSpan>
        </el-form-item>
        <el-form-item label="角色:" prop="roleId">
          <FormatSpan>{{ form.roleName }}</FormatSpan>
        </el-form-item>
        <el-form-item label="账号类型:" prop="adminType">
          <FormatSpan>{{ form.adminType }}</FormatSpan>
        </el-form-item>
        <el-form-item label="部门:" prop="departmentName">
          <FormatSpan>{{ form.departmentName }}</FormatSpan>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="edit-footer">
      <el-button size="small" @click="close">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: Object
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {}
    }
  },
  created() {},
  methods: {
    close() {
      this.$emit('update:visible', false)
    }
  }
}
</script>
<style lang="less"></style>
